import * as React from "react";
import styled from "../../styled";
import { IconChevronDown, IconChevronRight } from "./modal-icons";
const Section = styled("div") `
	padding: 0 16px;
	${({ divider }) => (divider ? "border-top: 1px dashed #dfdfdf;" : "")}
`;
const HeaderRow = styled("div") `
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-height: 48px;
	padding: 8px 0;
`;
const SectionTitle = styled("div") `
	font-size: 12px;
	font-weight: 500;
	line-height: 18px;
	color: ${({ theme }) => theme.box.text};
`;
const Toggle = styled("button") `
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	padding: 0;
	border: 1px solid #d5d7da;
	border-radius: 8px;
	background: #fff;
	color: #717680;
	cursor: pointer;
	box-shadow: 0 1px 2px rgba(10, 13, 18, 0.05);
	&:hover {
		background: #f9fafb;
	}
`;
const Body = styled("div") `
	padding-bottom: 16px;
`;
export class CollapsibleSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: !!props.defaultOpen };
    }
    isOpen() {
        return this.props.open === undefined ? this.state.open : this.props.open;
    }
    toggle = () => {
        const next = !this.isOpen();
        if (this.props.open === undefined)
            this.setState({ open: next });
        if (this.props.onToggle)
            this.props.onToggle(next);
    };
    render() {
        const { title, divider = true, children } = this.props;
        const open = this.isOpen();
        return (React.createElement(Section, { divider: divider },
            React.createElement(HeaderRow, null,
                React.createElement(SectionTitle, null, title),
                React.createElement(Toggle, { type: "button", onClick: this.toggle, "aria-expanded": open }, open ? React.createElement(IconChevronDown, null) : React.createElement(IconChevronRight, null))),
            open && React.createElement(Body, null, children)));
    }
}
//# sourceMappingURL=collapsible-section.js.map